import {Component, OnInit} from '@angular/core';
import {takeUntil} from "rxjs/operators";
import {ApiCommonService} from "@core/services/api-common.service";
import {Subject} from "rxjs";
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';

@Component({
  selector: 'app-query-customer-dialog',
  templateUrl: './query-customer-dialog.component.html',
  styleUrls: ['./query-customer-dialog.component.scss']
})
export class QueryCustomerDialogComponent implements OnInit {

  isOpenQueryCollapse = true;
  queryCustomerOrIdNo = '';
  queryCustomerRes: { idNo: string; customerName: string }[] = [];
  private readonly destroy$ = new Subject();

  constructor(
    private coreCommonService: ApiCommonService,
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef,
  ) {
  }

  ngOnInit(): void {
    // console.log("this is log from dialog: " + this.config.data.customerName);
    this.queryCustomerOrIdNo = this.config.data.customerName;
  }

  searchForCustomer(): void {
    if (this.queryCustomerOrIdNo) {
      this.coreCommonService
        .queryCustomer(this.queryCustomerOrIdNo)
        .pipe(takeUntil(this.destroy$))
        .subscribe((res) => {
          if (res.rtnCode === 0 && res.data) {
            this.queryCustomerRes = res.data;
            this.isOpenQueryCollapse = false;
          }
        });
    }
  }

  selectedIdNo(customer: { idNo: string; customerName: string }): void {
    this.ref.close(customer);
  }

  clearForCustomer(): void {
    this.queryCustomerRes = [];
    this.queryCustomerOrIdNo = '';
  }
}
